import { render, staticRenderFns } from "./GoodsBack.vue?vue&type=template&id=6172fc00"
import script from "./GoodsBack.vue?vue&type=script&lang=js"
export * from "./GoodsBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports